export enum StorageKeys {
  LinkParams = "@GTK/linkParams_",
  OverlayPreviewBgColor = "@GTK/overlayPreviewBgColor_"
}
